import React from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./moreServices.scss";

const MoreServices = () => {
  const navigate = useNavigate();

  const services = [
    {
      icon: "🛠️",
      title: "Brand Audit & Consulting",
      description:
        "Find out what your brand is missing and optimize your brand position and growth.",
      background: "linear-gradient(135deg, #0073e6, #004bb5)",
    },
    {
      icon: "📈",
      title: "Lead Generation",
      description:
        "Generate high-quality leads and nurture them into paying customers.",
      background: "linear-gradient(135deg, #0073e6, #004bb5)",
    },
    {
      icon: "✍️",
      title: "Creative Content",
      description:
        "Content that resonates with your customers and builds their trust in you.",
      background: "linear-gradient(135deg, #0073e6, #004bb5)",
    },
    {
      icon: "💻",
      title: "Web Development",
      description:
        "Build responsive and engaging websites to boost your online presence.",
      background: "linear-gradient(135deg, #0073e6, #004bb5)",
    },
    {
      icon: "📊",
      title: "Digital Marketing",
      description:
        "Promote your business effectively through multiple digital platforms.",
      background: "linear-gradient(135deg, #0073e6, #004bb5)",
    },
    {
      icon: "📦",
      title: "E-commerce Solutions",
      description:
        "End-to-end solutions for managing and growing your e-commerce store.",
      background: "linear-gradient(135deg, #0073e6, #004bb5)",
    },
    {
      icon: "💡",
      title: "Search Engine Optimization (SEO)",
      description:
        "Optimize your website to rank higher on search engines and attract organic traffic.",
      background: "linear-gradient(135deg, #0073e6, #004bb5)",
    },
    {
      icon: "🎯",
      title: "Pay-Per-Click (PPC) Advertising",
      description:
        "Drive targeted traffic to your website with strategic ad campaigns.",
      background: "linear-gradient(135deg, #0073e6, #004bb5)",
    },
    {
      icon: "📱",
      title: "Social Media Management",
      description:
        "Engage your audience with tailored strategies for social media platforms.",
      background: "linear-gradient(135deg, #0073e6, #004bb5)",
    },
  ];

  return (
    <div>
      <Helmet>
        <title>Digital Marketing Services | Arrow Digital Marketing</title>
        <meta
          name="description"
          content="Discover expert services including SEO, PPC, content marketing, web development, and more from Arrow Digital. Empower your brand today."
        />
        <link rel="canonical" href="https://arrowdigitalmarketing.com/services" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph Tags */}
        <meta property="og:title" content="Our Digital Marketing Services | Arrow Digital" />
        <meta
          property="og:description"
          content="Explore top-tier services from Arrow Digital: SEO, PPC, content creation, brand audits, and e-commerce solutions that drive business growth."
        />
        <meta property="og:image" content="https://arrowdigitalmarketing.com/images/services-banner.jpg" />
        <meta property="og:url" content="https://arrowdigitalmarketing.com/services" />
        <meta property="og:type" content="website" />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Arrow Digital Marketing Services" />
        <meta
          name="twitter:description"
          content="From SEO to e-commerce—Arrow offers tailored marketing services to grow your business online."
        />
        <meta name="twitter:image" content="https://arrowdigitalmarketing.com/images/services-banner.jpg" />
      </Helmet>

      <div className="banner">
        <h1>Our Expertise</h1>
        <p>Innovative Solutions for Modern Businesses</p>
      </div>

      <div className="services-container">
        <h2 style={{ color: "#000" }}>Our Services</h2>
        <p style={{ color: "#000", marginBottom: 100, marginTop: 50 }}>
          Arrow Digital has helped over a thousand happy clients to successfully leverage digital marketing channels,
          achieve optimal market fit for their product, and establish themselves as industry leading brands.
        </p>

        <div className="services-grid">
          {services.map((service, index) => (
            <div
              className="service-card"
              key={index}
              style={{ background: service.background }}
              onClick={() => navigate(`/service/${encodeURIComponent(service.title)}`)}
            >
              <div className="icon">{service.icon}</div>
              <h3 style={{ color: "#fbc531" }}>{service.title}</h3>
              <p style={{ color: "#fff" }}>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MoreServices;
